"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeVivedAPI = exports.VivedAPI = void 0;
const ObservableEntity_1 = require("./ObservableEntity");
class VivedAPI extends ObservableEntity_1.ObservableEntity {
}
exports.VivedAPI = VivedAPI;
function makeVivedAPI() {
    return new VivedAPIImp();
}
exports.makeVivedAPI = makeVivedAPI;
class VivedAPIImp extends VivedAPI {
    constructor() {
        super(...arguments);
        this.baseUrl = 'https://api.vivedlearning.com';
        this.getEndpointURL = (endpoint) => {
            return new URL(endpoint, this.baseUrl);
        };
        this._userAuthToken = undefined;
        this.clearAuthToken = () => {
            if (this._userAuthToken === undefined)
                return;
            this._userAuthToken = undefined;
            this.notify();
        };
        this.fetchAssetFile = ( /*assetId: string*/) => {
            return Promise.reject(this.functionNotInjectedError('fetchAssetFile'));
        };
        this.fetchAssetMeta = ( /*assetID: string*/) => {
            return Promise.reject(this.functionNotInjectedError('fetchAssetMeta'));
        };
        this.fetchAssetsForOwner = (ownerID) => {
            return Promise.reject(this.functionNotInjectedError('fetchAssetsForOwner'));
        };
        this.setAssetArchived = (assetID, archived) => {
            return Promise.reject(this.functionNotInjectedError('setAssetArchived'));
        };
        this.postAssetMeta = (data) => {
            return Promise.reject(this.functionNotInjectedError('postAssetMeta'));
        };
        this.createNewAsset = (data) => {
            return Promise.reject(this.functionNotInjectedError('createNewAsset'));
        };
        this.postAssetFile = (assetID, file) => {
            return Promise.reject(this.functionNotInjectedError('postAssetFile'));
        };
        this.deleteAsset = (assetID) => {
            return Promise.reject(this.functionNotInjectedError('deleteAsset'));
        };
    }
    get userAuthToken() {
        return this._userAuthToken;
    }
    set userAuthToken(token) {
        if (token === this._userAuthToken)
            return;
        this._userAuthToken = token;
        this.notify();
    }
    fetchApp(appID, version) {
        return Promise.reject(this.functionNotInjectedError("fetchApp"));
    }
    functionNotInjectedError(functionName) {
        return new Error(`API function ${functionName} has not been injected`);
    }
}
